// extracted by mini-css-extract-plugin
module.exports = {"LPPage":"AWSFargate_LPPage__3T2dC","contents":"AWSFargate_contents__2awFa","contact_wrapper":"AWSFargate_contact_wrapper__33104"};